import { memo } from "react";
import TextField from "../TextField";
import { CpfInputProps } from "./props.type";
import { Box } from "@mui/material";
import { formatCpfDisplay } from "@/utils/maskFormat";

const CpfInput = (props: CpfInputProps) => {
  return (
    <Box {...props.ContainerProps}>
      <TextField
        label={props.label}
        disabled={props.disabled}
        error={props.error}
        helperText={props.error ? props.errorText : undefined}
        value={props.value ?? ""}
        setValue={(v) => {
          props.setValue?.(formatCpfDisplay(v));
        }}
        onChange={props.onChange}
      />
    </Box>
  );
};

export default memo(CpfInput);
